/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { BrandingsIndexQueryParams, BrandingsIndexResponse } from '../types/BrandingsIndex'

/**
 * GET /brandings
 * @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::index
 */
export async function brandingsIndex(
	params?: BrandingsIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BrandingsIndexResponse>> {
	return axiosInstance.get('/brandings', { params, ...config })
}
